/**
 * Manages property pins and clustering
 * @param map  the instance of the map the layer exists in
 */
define(['c21/maps', 'jquery', 'bing', 'c21/track'], function () {
   "use strict";

   return function (map, backgroundPropertyTooltipManager) {
      var self = this,

         $ = require('jquery'),
         C21Maps = require('c21/maps'),
         BingMaps = require('bing'),
         track = require('c21/track'),

         m_map = map,
         m_clusterLayer,

         m_bInitialized = false,
         m_fnOnInitialize,

         createClusteredPin = function (cluster, latlong) {
            var pin = new BingMaps.Pushpin(latlong, {
               icon: '/images/mapping/office-cluster-pushpin-black.png',
               zIndex: C21Maps.getZindexFromLoc(
                  latlong.latitude,
                  latlong.longitude
               ),
               width: 27,
               height: 44,
               text: cluster.length.toString(),
               typeName: 'clusterPin',
               anchor: new BingMaps.Point(8, 31)
            });

            BingMaps.Events.addHandler(pin, 'click', function (e) {
               // Convert the pins into Location objects
               var aLocation = [];
               $.each(cluster, function (i, propertyPinExtra) {
                  var loc = propertyPinExtra.getLocation();
                  aLocation.push(loc);
               });

               // Set the map's view
               var bestview = BingMaps.LocationRect.fromLocations(aLocation);
               m_map.setView({
                  bounds: bestview
               });
            });

            return pin;
         },
         createPin = function (pinData) {
            var pin = new BingMaps.Pushpin(pinData._LatLong, {
               icon: '/images/search/grey-pushpin.png',
               zIndex: C21Maps.getZindexFromLoc(
                  pinData.getLatitude(),
                  pinData.getLongitude()
               ),
               width: 23,
               height: 18,
               typeName: 'propertyPin',
               anchor: new BingMaps.Point(6, 18)
            });

            C21Maps.onPinHoverIntent(m_map, pin, function () {
               track.doEvent('Hybrid Mapping', 'Property Map', 'Hover over a property on the map');
               backgroundPropertyTooltipManager.showHoverTooltip(pinData, true);
            }, function () {
               backgroundPropertyTooltipManager.hideHoverTooltip();
            });

            BingMaps.Events.addHandler(pin, 'click', function (e) {
               track.doEvent('Hybrid Mapping', 'Property Map', 'Click on a property on the map');
               backgroundPropertyTooltipManager.showClickTooltip(pinData);
            });

            return pin;
         },

         initialize = function () {
            C21Maps.onMapClick(m_map, function (e) {
               backgroundPropertyTooltipManager.clear();
            });
         };

      initialize();

      self.setProperties = function (aPinData) {
         if (m_bInitialized) {
            m_clusterLayer.SetData(aPinData);
         } else {
            m_fnOnInitialize = function () {
               m_clusterLayer.SetData(aPinData);
            };
         }
      };

      self.clearProperties = function () {
         self.setProperties([]);
         backgroundPropertyTooltipManager.clear();
      };

      self.onClusterModuleLoaded = function () {
         m_clusterLayer = new window.ClusteredEntityCollection(m_map, {
            singlePinCallback: createPin,
            clusteredPinCallback: createClusteredPin
         });

         var layer = m_clusterLayer.GetLayer();
         layer.setOptions({
            zIndex: 3
         });

         m_bInitialized = true;
         if (m_fnOnInitialize) {
            m_fnOnInitialize();
         }
      };
   };
});
